
import algoliaSearchJerseyName from './algoliaSearchJerseyName'

const getJerseyNameSuggestions = async ({ query, brandName, gender }) => {
	if (query && query.trim()) {
		const response = await algoliaSearchJerseyName(query, brandName, gender)

		// TODO: possibly need to relax the filters if there are no results...

		if (response && response.hits) {
			return { suggestions: response.hits }
		}
	}
	return { suggestions: [] }
}

export default getJerseyNameSuggestions



// WEBPACK FOOTER //
// ./src/dataservices/getJerseyNameSuggestions.js